import React from 'react'
import {observer} from 'mobx-react-lite'
import {Flex, Text} from '../../vanilla'
import {useOrderStore, useBasketStore} from '../../store/hooks/useStore'
import {FormattedNumber, FormattedMessage} from 'react-intl'
interface ShoppingTotalProps {
  inDrawer?: boolean
}

export const ShoppingTotal = observer(({inDrawer}: ShoppingTotalProps) => {
  const {orderTotal} = useOrderStore()
  const {basket, basketDeliveryCharge, carrierBagCharge} = useBasketStore()

  // Mini-cart keeps the full order total. Header shows products, delivery, and
  // the picking and packing charge, but excludes the small basket fee.

  const displayTotal = inDrawer
    ? Number(orderTotal) || 0
    : (Number(basket?.productTotal) || 0) +
      (Number(basketDeliveryCharge) || 0) +
      (Number(carrierBagCharge))

  const currency = basket?.currency ?? 'GBP'

  return (
    <Flex flexDirection="column" align="flex-end">
      <Text
        variant="unstyled"
        fontSize={inDrawer ? 'md' : 'xs'}
        fontWeight={inDrawer ? 'normal' : ['normal', 'medium']}
        as="span"
        lineHeight="none"
        data-test-selector={inDrawer ? 'cart-drawer-basket-total' : 'basket-total-amount'}
      >
        <FormattedNumber style="currency" currency={currency} value={displayTotal} />
      </Text>
      <Text
        color="textMuted"
        variant="unstyled"
        fontSize="xxs"
        fontWeight="normal"
        lineHeight="none"
        data-test-selector="basket-subtitle-text"
      >
        {inDrawer ? (
          'inc. fees'
        ) : (
          <FormattedMessage defaultMessage="(estimated)" />
        )}
      </Text>
    </Flex>
  )
})
